import {
  ACTIVE_STATUS_FILTER_POSTS,
  FORM_FILLED_FILTER_POSTS,
  LEAD_QUALITY_FILTER_POSTS,
  GENDER_FILTER_POSTS,
  GENDER_STATUS_FILTER_POSTS,
  RESET_FILTER_POSTS,
  SEARCH_FILTER_POSTS,
  STATUS_FILTER_POSTS,
  TYPE_FILTER_POSTS,
  IS_REJECTED_POST,
  FACE_STATUS_POST,
  AGE_FILTER_POSTS,
  LOCATION_FILTER_POSTS,
  CONVERSATION_FILTER_POSTS,
  DATE_RANGE_FILTER_POSTS,
} from "../actions/PostTypes";

const initialState = {
  filter: {
    search: "",
    gender: "all",
    status: "all",
    formFilled: "all",
    leadQuality: "all",
    type: "all",
    activeStatus: "completedAt",
    isRejectedValue: true,
    faceStatus: "pending",
    age: "",
    location: "",
    conversationFilter: "all",
    date: { startDate: null, endDate: null },
  },
};

export default function FilterReducer(state = initialState, action) {
  if (action.type === SEARCH_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, search: action.payload },
    };
  }
  if (action.type === GENDER_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, gender: action.payload },
    };
  }
  if (action.type === STATUS_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, status: action.payload },
    };
  }
  if (action.type === FORM_FILLED_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, formFilled: action.payload },
    };
  }
  if (action.type === LEAD_QUALITY_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, leadQuality: action.payload },
    };
  }
  if (action.type === TYPE_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, type: action.payload },
    };
  }
  if (action.type === ACTIVE_STATUS_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, activeStatus: action.payload },
    };
  }
  if (action.type === AGE_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, age: action.payload },
    };
  }
  if (action.type === LOCATION_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, location: action.payload },
    };
  }
  if (action.type === CONVERSATION_FILTER_POSTS) {
    return {
      ...state,
      filter: { ...state.filter, conversationFilter: action.payload },
    };
  }
  if (action.type === DATE_RANGE_FILTER_POSTS) {
    return {
      ...state,
      filter: {
        ...state.filter,
        date: {
          startDate: action.payload?.startDate ?? null,
          endDate: action.payload?.endDate ?? null,
        },
      },
    };
  }
  if (action.type === GENDER_STATUS_FILTER_POSTS) {
    return {
      ...state,
      filter: {
        ...state.filter,
        gender: action.payload.gender,
        status: action.payload.status,
      },
    };
  }
  if (action.type === RESET_FILTER_POSTS) {
    return {
      ...state,
      filter: {
        ...state.filter,
        gender: "all",
        status: "all",
        formFilled: "all",
        leadQuality: "all",
        type: "all",
        activeStatus: "completedAt",
        age: "",
        location: "",
        search: "",
        date: { startDate: null, endDate: null },
      },
    };
  }
  if (action.type === IS_REJECTED_POST) {
    return {
      ...state,
      filter: {
        isRejectedValue: action.payload,
        search: "",
        gender: "all",
        status: "all",
        formFilled: "all",
        leadQuality: "all",
        type: "all",
        activeStatus: "createdAt",
        faceStatus: "pending",
        age: "",
        location: "",
      },
    };
  }
  if (action.type === FACE_STATUS_POST) {
    return {
      ...state,
      filter: {
        faceStatus: action.payload,
        isRejectedValue: true,
        search: "",
        gender: "all",
        status: "all",
        formFilled: "all",
        leadQuality: "all",
        type: "all",
        activeStatus: "createdAt",
        age: "",
        location: "",
      },
    };
  }

  return state;
}
